module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-serviceRules"
  }, [_vm._m(0), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "cont"
  }, _vm._l((_vm.tabDta), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        activeClass: item.active
      },
      on: {
        "click": function($event) {
          return _vm.clickTab(index)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 1),
      expression: "currentTab == 1"
    }],
    staticClass: "distribution"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("配送安装范围")]), _vm._m(1), _c('div', {
    staticClass: "title"
  }, [_vm._v("大件入户说明")]), _vm._m(2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 2),
      expression: "currentTab == 2"
    }],
    staticClass: "after-sales"
  }, [_vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 3),
      expression: "currentTab == 3"
    }],
    staticClass: "Q-A"
  }, [_vm._m(7), _vm._m(8)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImg"
  }, [_c('img', {
    attrs: {
      "src": require("assets/serviceRules/img1.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("服务政策")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·懂窝配送范围涵盖全国各地(除新疆、西藏、青海三省)。")]), _vm._v(" "), _c('span', [_vm._v("·大件家具提供免费配送服务,小件家居按城市距离分级,您可能需要承担不同金额的快递费。")]), _vm._v(" "), _c('span', [_vm._v("·全拆装大件家具在上海地区支持免费“送货上门及组装”服务(具体详情请治懂窝客服)。")]), _vm._v(" "), _c('span', [_vm._v("·悬挂灯具部分,目前尚未提供吊灯与顶棚的安装接电服务,敬请见谅。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·大件家具的物流由懂窝甄选的第三方服务公司为您服务,服务公司或懂窝工作人员会与您致电预约上门时间,期间请保持电话通畅。")]), _vm._v(" "), _c('span', [_vm._v("·目前尚不支持指定时间上门服务,请您预估合理的收货时间,避免因到货后无法收货而产生的仓储费用,懂窝为您提供3个自然日的免费仓储,超过3个工作日开始收取仓储费。该笔费用将由物流公司直接向您收取,请您支付前仔细核对")]), _vm._v(" "), _c('span', [_vm._v("·若您的住所没有电梯或电梯无法使用,七楼及七楼以下,由懂窝合作的第三方公司给您免费提供上楼服务;若入户后有楼层或地下室的,则按抬楼楼层总数来计算费用。")]), _vm._v(" "), _c('span', [_vm._v("·因部分家具尺寸较大,请在购买前对楼梯、电梯、房门等入户结构进行尺寸测量,确认能否上楼入户。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("售后服务")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·关于发货:一般情况下,生产周期为45-60天,具体请与客服沟通。")]), _vm._v(" "), _c('span', [_vm._v("·关于配送:全国大部分地区,包邮送货入户。无电梯或者电梯不可进情况下,七楼以上需颜外加收上楼费用。")]), _vm._v(" "), _c('span', [_vm._v(" ·关于仓储:货物到达当地后,3日内免费仓储,超出后则按照10元/天/m³进行收费。")]), _vm._v(" "), _c('span', [_vm._v("·关于安装:请与在线客服关系,我们安排工人师傅与您孩约上门安装时间(免费安装)")]), _vm._v(" "), _c('span', [_vm._v(" ·关于退换货:提供七天无理由退换货服务,如因用户原因产生退换货,则需支付10%-20%不等的耗损费。缺失包装,另需支"), _c('br'), _vm._v(" 付5%-10%的费用。")]), _vm._v(" "), _c('span', [_vm._v(" ·关于质保:所出售的大件家具产品,提供三年质保服务:非人为因素的商品损坏,提供免费维修服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("三年质保服务")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·懂窝为出售的家具产品提供为期三年的质量保障服务。质保期内，若产品在正常使用和维护的情况下出现问题，请第一时间联系懂窝客服，若属于产品本身质量问题(非人为原因),我们将为您维修,直至问题解决.质保期以产品实际签收日期为起始日,请您在签收货物单据时,注意查看交货日期。")]), _vm._v(" "), _c('span', [_vm._v("·质保期限内,若因产品质量问题而产生的售后相关费用,由懂窝承担;非产品质量问题,产生的售后相关费用,由客户承担。超出质保期限，懂窝将根据实际情况为您提供服务,并收取原材料成本、上门维修费等合理费用,具体金额将会在每次服务发生前与您商定。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("退换货政策")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。")]), _vm._v(" "), _c('span', [_vm._v("·由于家具属于定做的商品,甲方提出无理由退换货的，需支付相应耗损费。")]), _vm._v(" "), _c('span', [_vm._v("·若退换货订单中包含赠品,甲方需将赠品寄回,若赠品破损或遗失，需扣除赠品价值等额的货款。若您已经开具发票而发票遗失,则相应的退税点(13%)需由您承担。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("无法受理范围")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·因拍摄设备 、显示器、光线等原因产生的色差,不属于商品质量问题")]), _vm._v(" "), _c('span', [_vm._v("·因商品测量标准不一致导致的尺寸问题,在相关标准规定的尺寸误差内,不属于商品质量问题;")]), _vm._v(" "), _c('span', [_vm._v("·材料，工艺产生的天然瑕疵,不属于商品质量问题")]), _vm._v(" "), _c('span', [_vm._v("·未按懂窝标准收货程序签收，拆包不当造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·未按照懂窝产品组装说明书操作，错误组装造成的产品损坏")]), _vm._v(" "), _c('span', [_vm._v("·未按照组装说明书要求，自行更换部件造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·自行拆装 、调换产品,或在错误的环境使用造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·非专业人士修理导致的损坏")]), _vm._v(" "), _c('span', [_vm._v("·由于不正当使用产品或部件造成的人身和财产损失")]), _vm._v(" "), _c('span', [_vm._v("·不能提供购买凭证或者擅自更改购买日期者")]), _vm._v(" "), _c('span', [_vm._v("·因其它不可抗拒力(地震,火灾)等造成的产品损坏")]), _vm._v(" "), _c('span', [_vm._v("·其它使用，维护，保管不当及人为损坏的情况")]), _vm._v(" "), _c('span', [_vm._v("·玻璃镜子发生霉变和雾光的三包期限为六个月。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于配送")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：不同类型的家居，上楼配送安装是一样的费用嘛？")]), _c('span', [_vm._v("A：七楼及一下免费上楼，八层(含八层)起边几、茶几、餐桌、餐椅、床头柜等按15元/层/件计算;沙发、床垫、床、柜体(床头柜除外)、排骨架、大理石产品等按30元/层/件计算。若入户后有楼层或地下室的，则按抬楼楼层总数来计算费用。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:如何预约上门时间？")]), _c('span', [_vm._v("A:懂窝目前尚不支持指定时间上门服务，请您预估合理的收货时间，避免到货后无法收货而产生仓储费用。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:家具的配送范围？")]), _c('span', [_vm._v("A：懂窝配送范围覆盖全国各地，除新疆、西藏、青海三省。大件免费配送，小件按城市距离分级。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：能免费上门组装嘛？")]), _c('span', [_vm._v("A:全拆大件家具，在上海地区支持免费“送货上门及组装”服务，详情可联系客服。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：买的吊灯能帮忙安装吗？")]), _c('span', [_vm._v("A：懂窝目前尚未提供吊灯与顶棚的安装接电服务，敬请见谅。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于售后")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:下单后多久能到货")]), _c('span', [_vm._v("A：家具为定做商品，一般情况下，生产周期为45-60天，具体请与客服沟通。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：家具到家后不满意，我能退货吗？")]), _c('span', [_vm._v("A：甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：家具使用时有损伤，怎么办？")]), _c('span', [_vm._v("A：我们为所出售的大件家具产品，提供三年质保服务，非人为因素的商品损坏，提供免费维修服务。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70b55148"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceRules.vue
// module id = 452
// module chunks = 0